import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, EventEmitter, Output, AfterViewInit, OnDestroy, Input, Inject, PLATFORM_ID } from '@angular/core';

@Directive({
  selector: '[lazyLoader]',
  standalone: true,
  exportAs: 'lazyLoader'
})
export class LazyLoaderDirective implements AfterViewInit, OnDestroy {
  @Output() lazyLoad = new EventEmitter<LazyLoaderDirective>();
  @Input() offset: string = '100px';
  private observer?: IntersectionObserver;

  constructor(
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: Object // ✅ inject platform ID
  ) {}

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.observeLastItem(); // ✅ only runs on CSR
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  private observeLastItem() {
    const options = {
      root: null,
      rootMargin: this.offset,
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.lazyLoad.emit(this);
        }
      });
    }, options);

    const target = this.el.nativeElement.lastElementChild;
    if (target) {
      this.observer.observe(target);
    }
  }

  updateObserver() {
    if (this.observer) {
      this.observer.disconnect();
      const target = this.el.nativeElement.lastElementChild;
      if (target) {
        this.observer.observe(target);
      }
    }
  }
}
